export const isValidVin = (value = '') => /^[A-HJ-NPR-Z0-9]{17}$/i.test(value);
